import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';

export const getBaseTeammateSuggestionList = ({
  includeOrgMembers = true,
  recurringMeetingsWithoutWorkspaces,
  members,
  formValues,
  teammateIds,
  currentUserId,
}) => {
  const formValuesEmails = Object.values(formValues).map(({ teammateEmail, email }) => teammateEmail || email);
  const formValuesIds = Object.values(formValues)
    .map(({ userId }) => userId)
    .filter(n => n);
  const formValuesRecurringMeetingIds = Object.values(formValues).map(({ recurringMeetingId }) => recurringMeetingId);
  const suggestionListFromRecurringMeetings = recurringMeetingsWithoutWorkspaces
    .filter(({ id }) => !formValuesRecurringMeetingIds.includes(id))
    .map(({ attendees, name, id, source }) => {
      const valid_attendees = attendees.filter(
        ({ email, userId }) =>
          userId !== currentUserId &&
          !formValuesEmails.includes(email) &&
          !teammateIds.includes(userId) &&
          !formValuesIds.includes(userId)
      );
      const suggestionType = attendees.length === 2 ? 'one_on_one_meeting' : 'group_meeting';
      return valid_attendees.map(attendee => {
        return {
          recurringMeeting: { name, id, source },
          person: { userId: attendee.userId, email: attendee.email, fullName: attendee.fullName },
          suggestionType,
        };
      });
    })
    .flat();

  const suggestionListFromRecurringMeetingsSorted = sortBy(suggestionListFromRecurringMeetings, ({ suggestionType }) =>
    suggestionType === 'one_on_one_meeting' ? -1 : 1
  );

  let resultList;

  if (includeOrgMembers) {
    const suggestionListFromMembers = members
      .filter(({ email }) => !formValuesEmails.includes(email))
      .map(({ email, fullName, avatar }) => {
        return {
          person: { email, fullName, avatar },
          recurringMeeting: null,
          suggestionType: 'member',
        };
      });
    resultList = suggestionListFromRecurringMeetingsSorted.concat(suggestionListFromMembers);
  } else {
    resultList = suggestionListFromRecurringMeetingsSorted;
  }

  return uniqBy(resultList, suggestion => suggestion.person.email);
};
